import type {
  BarometerSuccess,
} from '@autobid/strapi-integration/typescript/auction/barometerCar'
import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import {
  getBarometerQueryKey,
} from '@autobid/ui/composables/car/data/useBarometerCar'
import { BAROMETER_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useBarometerSocket'
import { useQueryClient } from '@tanstack/vue-query'

export function useBarometerAuctionTimeChange() {
  const { startListen } = useWebSocketStore()
  const queryClient = useQueryClient()

  const auctionTimeChange = () => {
    startListen({
      eventName: 'premium.AUCTION_TIME_CHANGE',
      callbackName: BAROMETER_SOCKET_CALLBACK,
      callback: (event) => {
        const { active, auctionId } = event.context
        const queryKey = getBarometerQueryKey({ type: 'item' })

        queryClient.setQueriesData(
          queryKey,
          (
            data?: BarometerSuccess['data']['singleItem'],
          ): BarometerSuccess['data']['singleItem'] | undefined => {
            if (!data)
              return data

            if (data.item.itemData.auctionId !== auctionId)
              return data

            if (data.item.itemData.stage === 'IN_AUCTION')
              return data

            return {
              ...data,
              item: {
                ...data.item,
                itemData: {
                  ...data.item.itemData,
                  hotbidDuration: {
                    ...data.item.itemData.hotbidDuration,
                    active,
                  },
                },
              },
            }
          },
        )
      },
    })
  }

  return { auctionTimeChange }
}
